<section class="season-directory">
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>

  <header class="season-header">
    <div>
      <h1>Сезоны</h1>
      <span>{{ loading ? 'Обновляем данные...' : seasons.length + ' сезонов' }}</span>
    </div>
  </header>

  <div class="season-workspace" *ngIf="!loading; else loadingState">
    <section class="seasons-panel">
      <div class="panel-tools">
        <div>
          <span class="eyebrow">Листинг</span>
          <h2>Сезоны чемпионатов</h2>
        </div>
        <button class="action-button panel-add-button" type="button" (click)="openCreate()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          <span>Добавить</span>
        </button>
      </div>

      <div class="season-card-grid" *ngIf="sortedSeasons.length; else emptySeasons">
        <button
          class="season-card-button"
          type="button"
          *ngFor="let season of sortedSeasons; trackBy: trackById"
          [class.active]="selectedSeasonId === season.id"
          (click)="selectSeason(season)"
        >
          <header>
            <span>
              <strong>{{ season.name }}</strong>
              <small>{{ getChampionshipName(season) }}</small>
            </span>
            <b [class.current]="season.isCurrent">{{ season.isCurrent ? 'Активный' : 'Архив' }}</b>
          </header>
          <div class="season-card-metrics">
            <span>Событий <strong>{{ getSeasonStats(season).eventsTotal }}</strong></span>
            <span>Билетов <strong>{{ getSeasonStats(season).ticketsTotal }}</strong></span>
            <span>Оплачено <strong>{{ formatMoney(getSeasonStats(season).paidRevenue) }}</strong></span>
          </div>
        </button>
      </div>

      <ng-template #emptySeasons>
        <div class="empty-state">Сезоны пока не добавлены.</div>
      </ng-template>
    </section>

    <main class="season-detail" *ngIf="selectedSeason as season">
        <section class="season-card hero-card">
          <div>
            <span class="eyebrow">Сезон</span>
            <h2>{{ season.name }}</h2>
            <p>{{ getChampionshipName(season) }} · {{ season.isCurrent ? 'активный сезон' : 'архивный сезон' }}</p>
          </div>
          <div class="hero-actions">
            <button class="secondary-button" type="button" (click)="openEdit(season)">Редактировать</button>
            <button class="danger-button" type="button" (click)="deleteSeason(season)">Удалить</button>
          </div>
        </section>

        <section class="stats-grid">
          <article class="stat-card">
            <span>События</span>
            <strong>{{ totalStats.eventsTotal }}</strong>
            <small>{{ totalStats.soldTicketsTotal }}/{{ totalStats.ticketsTotal }} билетов продано</small>
          </article>
          <article class="stat-card">
            <span>Плановая выручка</span>
            <strong>{{ formatMoney(totalStats.plannedRevenue) }}</strong>
            <small>все билеты сезона</small>
          </article>
          <article class="stat-card">
            <span>Оплачено</span>
            <strong>{{ formatMoney(totalStats.paidRevenue) }}</strong>
            <small>по проданным билетам</small>
          </article>
          <article class="stat-card">
            <span>Факт после расходов</span>
            <strong [class.negative]="totalStats.actualProfit < 0">{{ formatMoney(totalStats.actualProfit) }}</strong>
            <small>оплаты минус закупка и расходы</small>
          </article>
        </section>

        <section class="season-card">
          <div class="panel-heading">
            <div>
              <span class="eyebrow">Статистика</span>
              <h2>Регулярка и плей-офф</h2>
            </div>
          </div>

          <div class="phase-stats">
            <article>
              <strong>Регулярный сезон</strong>
              <span>{{ formatStatLabel(regularStats) }}</span>
              <b>{{ formatMoney(regularStats.actualProfit) }}</b>
            </article>
            <article>
              <strong>Плей-офф</strong>
              <span>{{ formatStatLabel(playoffStats) }}</span>
              <b>{{ formatMoney(playoffStats.actualProfit) }}</b>
            </article>
          </div>
        </section>

        <section class="season-card">
          <div class="panel-heading">
            <div>
              <span class="eyebrow">Фазы</span>
              <h2>Структура сезона</h2>
            </div>
            <div class="heading-actions">
              <button class="secondary-button" type="button" [disabled]="syncingPhases" (click)="syncDefaultPhases()">{{ syncingPhases ? 'Проверяем...' : 'Стандартные фазы' }}</button>
              <button class="primary-button" type="button" (click)="openCreatePhase()">Добавить фазу</button>
            </div>
          </div>

          <div class="phase-table-wrap" *ngIf="flattenedSelectedPhases.length; else emptyPhases">
            <table class="phase-table">
              <thead>
                <tr>
                  <th>Фаза</th>
                  <th>Тип</th>
                  <th>Порядок</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let phase of flattenedSelectedPhases; trackBy: trackById">
                  <td>
                    <strong [class.child-phase]="phase.parentPhaseId">{{ phase.name }}</strong>
                    <small>{{ phase.slug }}</small>
                  </td>
                  <td><span class="type-pill" [class]="'type-' + phase.type">{{ getPhaseTypeName(phase.type) }}</span></td>
                  <td>{{ phase.sortOrder }}</td>
                  <td>
                    <div class="row-actions">
                      <button class="icon-button" type="button" title="Редактировать" aria-label="Редактировать" (click)="openEditPhase(phase)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                      </button>
                      <button class="icon-button danger" type="button" title="Удалить" aria-label="Удалить" (click)="deletePhase(phase)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #emptyPhases>
            <div class="empty-state">Фазы не добавлены. Нажмите “Стандартные фазы”.</div>
          </ng-template>
        </section>
    </main>
  </div>

  <ng-template #loadingState>
    <div class="loading-card">Загрузка сезонов...</div>
  </ng-template>

  <div class="modal-backdrop" *ngIf="modalOpen">
    <section class="season-modal" role="dialog" aria-modal="true" [attr.aria-label]="editingSeasonId ? 'Редактирование сезона' : 'Новый сезон'">
      <header class="modal-header">
        <h2>{{ editingSeasonId ? 'Редактирование сезона' : 'Новый сезон' }}</h2>
        <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="closeModal()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>

      <form class="season-form" (ngSubmit)="saveSeason()">
        <label class="wide">
          <span>Чемпионат</span>
          <select class="form-select" name="seasonChampionship" [(ngModel)]="formData.championshipId" required>
            <option value="">Выберите чемпионат</option>
            <option *ngFor="let championship of championships; trackBy: trackById" [value]="championship.id">{{ championship.name }}</option>
          </select>
        </label>
        <label>
          <span>Период</span>
          <input class="form-control" name="seasonYear" [(ngModel)]="formData.seasonYear" placeholder="2026/2027" required>
        </label>
        <label class="checkbox-label">
          <input type="checkbox" name="seasonCurrent" [(ngModel)]="formData.isCurrent">
          <span>Активный сезон</span>
        </label>
        <div class="modal-actions wide">
          <button class="secondary-button" type="button" (click)="closeModal()">Отмена</button>
          <button class="primary-button" type="submit" [disabled]="saving">{{ saving ? 'Сохраняем...' : 'Сохранить' }}</button>
        </div>
      </form>
    </section>
  </div>

  <div class="modal-backdrop" *ngIf="phaseModalOpen">
    <section class="season-modal" role="dialog" aria-modal="true" [attr.aria-label]="editingPhaseId ? 'Редактирование фазы' : 'Новая фаза'">
      <header class="modal-header">
        <h2>{{ editingPhaseId ? 'Редактирование фазы' : 'Новая фаза' }}</h2>
        <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="closePhaseModal()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>

      <form class="season-form" (ngSubmit)="savePhase()">
        <label>
          <span>Название</span>
          <input class="form-control" name="phaseName" [(ngModel)]="phaseFormData.name" placeholder="Регулярный сезон" required>
        </label>
        <label>
          <span>Slug</span>
          <input class="form-control" name="phaseSlug" [(ngModel)]="phaseFormData.slug" placeholder="regular">
        </label>
        <label>
          <span>Тип</span>
          <select class="form-select" name="phaseType" [(ngModel)]="phaseFormData.type" (ngModelChange)="onPhaseTypeChange()" required>
            <option *ngFor="let option of phaseTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </label>
        <label>
          <span>Порядок</span>
          <input class="form-control" type="number" min="1" name="phaseSortOrder" [(ngModel)]="phaseFormData.sortOrder" required>
        </label>
        <label class="wide" *ngIf="phaseFormData.type === 'playoff_stage'">
          <span>Родительская фаза</span>
          <select class="form-select" name="phaseParent" [(ngModel)]="phaseFormData.parentPhaseId" required>
            <option value="">Выберите плей-офф</option>
            <option *ngFor="let phase of phaseParentOptions; trackBy: trackById" [value]="phase.id">{{ phase.name }}</option>
          </select>
        </label>
        <div class="modal-actions wide">
          <button class="secondary-button" type="button" (click)="closePhaseModal()">Отмена</button>
          <button class="primary-button" type="submit" [disabled]="saving || !canSavePhase">{{ saving ? 'Сохраняем...' : 'Сохранить' }}</button>
        </div>
      </form>
    </section>
  </div>
</section>
